export * from './NotificacaoServiceAdapter'